import AuthGuard from "./AuthGuard";
import DashboardEmbedUrl from "../pages/dashboard/other/Other";
import OtherLayout from "../layouts/otherLayout";
const otherRoutes = [
  {
    path: "/sbee",
    element: (
      <AuthGuard>
        <OtherLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <DashboardEmbedUrl />,
      },
    ],
  },
];

export default otherRoutes;
